import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'm' | 's';
  /** disabled with "…" announced: the action is running */
  busy?: boolean;
  icon?: ReactNode;
  /** when the caller lacks a permission: the button is disabled and says which one in its title */
  missingPermission?: string | null;
}

export function Button({ variant = 'secondary', size = 'm', busy = false, icon, missingPermission, children, className = '', disabled, title, type = 'button', ...rest }: ButtonProps) {
  const classes = ['btn', variant !== 'secondary' ? `btn-${variant}` : '', size === 's' ? 'btn-s' : '', busy ? 'btn-busy' : '', className].filter(Boolean).join(' ');
  const blocked = Boolean(missingPermission);
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || busy || blocked}
      aria-busy={busy || undefined}
      title={blocked ? `You lack the '${missingPermission}' permission.` : title}
      {...rest}
    >
      {busy ? <span className="spinner" aria-hidden="true" /> : icon}
      {children}
      {busy && <span className="visually-hidden">…</span>}
    </button>
  );
}

export function IconButton({ label, children, className = '', ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { label: string }) {
  return (
    <button type="button" className={`icon-button ${className}`} aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}
